import { Component, input, InputSignal } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { UpdateCard as UpdateCardInterface } from '../../data/interfaces/UpdateCardInterface';
@Component({
  selector: 'app-update-card',
  imports: [FontAwesomeModule],
  templateUrl: './update-card.html',
  styleUrl: './update-card.scss',
})
export class UpdateCard {

  update: InputSignal<UpdateCardInterface> = input<UpdateCardInterface>({
    imgLink: 'assets/update-card-1.jpg',
    title: 'Titulo',
    subtitle: 'Subtitulo',
    text: 'Contenido Lorem ipsum dolor sit amet consectetur adipisicing elit. Vero dicta minus quo, impedit similique explicabo autem blanditiis aspernatur doloribus eius odio minima ex distinctio labore laboriosam expedita sequi culpa. Saepe!',
    link: '#',
  })

}
